import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useSelector } from 'react-redux';

import IdentityManager from '../../../common/services/identity/IdentityManagerFactory';

import { RootState } from '../../../redux/store';

import Icon from '../icon/icon';
import Logo from '../logo/logo';

import './noMatch.scss';

const NoMatch: React.FC = () => {
  const { t } = useTranslate();

  const identity = IdentityManager.getManager();

  const user: string | null | undefined = useSelector((state: RootState) => state.user.name);

  let url = location.hostname === 'localhost' ? location.hostname + ':' + location.port : location.hostname;
  let redirect = 'https://' + url + '/home';

  return (
    <div className='no-match-content'>
      <div className='no-match-logo'>
        <Icon name='fas fa-exclamation-circle' className='no-match-error-icon' />
        <Logo logoSource='/branding/logo.png' />
      </div>

      <div className='no-match-text-large'>
        <span className='no-match-event-info'> {t('NO_MATCH.TEXT1')}</span>
        <span> {t('NO_MATCH.TEXT2')}</span>
      </div>
      <div className='no-match-text-info'>
        <p>{t('NO_MATCH.INFO_TEXT1')}</p>
        <p>{t('NO_MATCH.INFO_TEXT2')}</p>
        <a className='link-text' href='mailto:support@sanne.com'>
          {t('NO_MATCH.INFO_TEXT_MAIL')}
        </a>
      </div>
      <div className='no-match-text-small'>
        <span>
          {t('NO_MATCH.SIGNED_PERSON')} {user}
        </span>
      </div>

      <div className='no-match-buttons'>
        <a className='no-match-redirect-btn' href={redirect}>
          {t('NO_MATCH.BACK_BUTTON')}
        </a>
        <div className='no-match-logout pointer' onClick={() => identity.signOut()}>
          {t('NO_MATCH.LOGOUT')}
        </div>
      </div>
    </div>
  );
};

export default NoMatch;
